<script setup lang="ts">
import { computed } from 'vue';
import {
  AGENT_BUILDS,
  buildFor,
  detectOs,
  downloadUrl,
} from '../print/agent.download';

const detected = computed(() => buildFor(detectOs(navigator)));
const others = computed(() =>
  AGENT_BUILDS.filter((build) => build.os !== detected.value?.os),
);
</script>

<template>
  <section
    class="bg-creux flex flex-col gap-3 rounded-[24px] p-4"
    aria-label="Agent d’impression"
  >
    <div class="flex flex-col gap-[2px]">
      <p class="text-[14px] leading-[20px] font-semibold">Agent d’impression</p>
      <p class="text-encre-douce text-[12px] leading-[17px]">
        À installer sur le PC relié à l’imprimante, puis à laisser démarré.
      </p>
    </div>

    <template v-if="detected">
      <a
        :href="downloadUrl(detected)"
        class="bg-primaire text-primaire-encre flex h-12 w-full cursor-pointer items-center justify-center rounded-[12px] px-5 text-[14px] leading-[1.4] font-semibold active:brightness-95"
        data-testid="agent-download"
      >
        Télécharger pour {{ detected.label }}
      </a>
      <p class="text-encre-douce text-[12px] leading-[17px]">
        {{ detected.hint }}
      </p>
    </template>
    <p v-else class="text-encre-douce text-[12px] leading-[17px]">
      Cet appareil ne peut pas faire tourner l’agent : installez-le sur un PC
      Windows, macOS ou Linux du même réseau que l’imprimante.
    </p>

    <p class="text-encre-douce text-[12px] leading-[17px]">
      {{ detected ? 'Un autre système ?' : 'Choisissez le système du PC :' }}
      <template v-for="(build, index) in others" :key="build.os">
        <a :href="downloadUrl(build)" class="underline">{{ build.label }}</a
        >{{ index < others.length - 1 ? ' · ' : '' }}
      </template>
    </p>
  </section>
</template>
